import { Types } from "../actions/auth";

export default function authReducer(
  state = {
    loading: false,
    success: false,
    successPassword: "",
    successPasswordReset: "",
    errorPasswordReset: "",
    successPasswordEmail: "",
    errorPasswordEmail: "",
  },
  action,
) {
  switch (action.type) {
    case Types.AUTH_OATH_REQUEST:
      return { ...state, loading: true };
    case Types.AUTH_OATH_SUCCEEDED:
      return { ...state, success: true };
    case Types.AUTH_OATH_ERROR:
      return { ...state, error: action.error, loading: false };
    case Types.AUTH_LOGIN_ADMIN_REQUEST:
      return { ...state, loading: true };
    case Types.AUTH_FLAG:
      return { ...state, success: false };
    case Types.AUTH_CHANGEPASSWORD_REQUEST:
      return { ...state, loading: true };
    case Types.AUTH_CHANGEPASSWORD_REQUEST_SUCCEEDED:
      return { ...state, loading: false, successPassword: action.msj };
    case Types.AUTH_CHANGEPASSWORD_REQUEST_ERROR:
      return {
        ...state,
        error: action.msj,
        loading: false,
      };
    case Types.AUTH_RESET_PASSWORDEMAIL_REQUESTED:
      return { ...state, loading: true };
    case Types.AUTH_RESET_PASSWORDEMAIL_SUCCEEDED:
      return {
        ...state,
        data: action.data,
        successPasswordEmail: action.msj,
        loading: false,
      };
    case Types.AUTH_RESET_PASSWORDEMAIL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
        errorPasswordEmail: action.msj,
      };
    case Types.AUTH_RESET_PASSWORD_REQUESTED:
      return {
        ...state,
        loading: true,
        errorPasswordReset: "",
        errorPasswordEmail: "",
      };
    case Types.AUTH_RESET_PASSWORD_SUCCEEDED:
      return {
        ...state,
        data: action.data,
        errorPasswordReset: "",
        errorPasswordEmail: "",
        successPasswordReset: action.msj,
      };
    case Types.AUTH_RESET_PASSWORD_ERROR:
      return {
        ...state,
        errorPasswordReset: action.msj,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}
